import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=4e69faab&scoped=true&"
import script from "./Accueil.vue?vue&type=script&lang=js&"
export * from "./Accueil.vue?vue&type=script&lang=js&"
import style0 from "./Accueil.vue?vue&type=style&index=0&id=4e69faab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e69faab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
